import { type IAgentUserQuery } from 'application/querySchemas/IAgentUserQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
// import { type IAgentUserFactory } from 'domain/entities/factories/AgentUser';
import { type IAgentCheckTokenClient } from 'interfaceAdapter/gatewaySchemas/IAgentCheckTokenClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentUserQuery implements IAgentUserQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly token: IAgentUserTokenRepository,
        @inject('IAgentCheckTokenClient')
        public readonly checkTokenClient: IAgentCheckTokenClient,
    ) {
        // @inject('IAgentUserFactory')
        // public readonly factory: IAgentUserFactory,
    }

    public checkToken = async (incrementLoginCount: boolean): Promise<any> => {
        const token = this.token.get();
        if (!token) {
            return {
                user: null,
                status: false,
            };
        }
        const { data, status } = await this.checkTokenClient.get({
            token,
            addLoginCount: incrementLoginCount,
        });
        // TODO buildをサボっている
        // return this.factory.build(data);
        return {
            user: data,
            status: status === 'valid',
        };
    };
}
